import { TrashIcon } from '@/assets/images';
import { resetAlertModal, setAlertModal } from '@/components/AlertModalRoot/alertModalService';
import { i18n } from '@/localization/i18n';

/**
 * Shows the shared delete-chat confirmation popup, then runs `onConfirm`.
 *
 * Mirrors the block confirmation helper (handleToggleBlockClick) so callers
 * reuse a single modal config instead of duplicating it. The actual delete
 * (and its offline guard) lives in the `onConfirm` callback.
 */
export const handleDeleteChatClick = ({ isGroup = false, onConfirm }) => {
   const modalId = 'deleteChatModal';
   const typeLabel = isGroup
      ? i18n.t('group.GROUP_NAME_LABEL').toLowerCase()
      : i18n.t('chat.CHATS_TITLE').toLowerCase().slice(0, -1);

   setAlertModal({
      id: modalId,
      visible: true,
      icon: (
         <div className="alert-modal-icon-inner ct-flexCenter">
            <TrashIcon className="alert-modal-icon ct-flexCenter" />
         </div>
      ),
      title: isGroup ? i18n.t('chat.DELETE_GROUP') : i18n.t('chat.DELETE_CHAT'),
      description: i18n.t('chat.DELETE_DESC', { type: typeLabel }),
      yesButton: i18n.t('chat.DELETE'),
      noButton: i18n.t('common.CANCEL'),
      yesAction: () => {
         onConfirm?.();
         resetAlertModal(modalId);
      },
      noAction: () => resetAlertModal(modalId),
      onRequestClose: () => resetAlertModal(modalId),
      customClassName: 'alert-modal-delete-v2',
   });
};
